import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addNewGroup, updateModifyGroupState, gameByPkg } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage],
  props: {
    propsData: Object
  },
  data: function data() {
    return {
      dialogShow: false,
      serverID: [],
      paramsData: {
        groupID: '',
        groupName: '',
        channels: '',
        pkgs: []
      },
      rules: {
        groupID: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        groupName: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }]
      },
      isUpd: true,
      serverType: [{
        label: this.$t('show'),
        value: 1
      }, {
        label: this.$t('notShow'),
        value: 0
      }],
      pkgList: [],
      checked: false
    };
  },
  watch: {
    "serverListYJ": function serverListYJ(value) {
      this.severChange(this.serverID);
    }
  },
  created: function created() {
    this.getPkgList();
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    selectAll: function selectAll() {
      var _this = this;

      this.serverID = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this.serverID.push(item.serverID);
        });
      } else {
        this.serverID = [];
      }
    },
    severChange: function severChange(val) {
      if (val.length === this.serverListYJ.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    getPkgList: function getPkgList() {
      var _this2 = this;

      gameByPkg({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.pkgList = res.data;
        }
      });
    },
    open: function open(data, type, serverChannel) {
      this.serverChannel = serverChannel;
      this.serverType = [{
        label: this.$t('show'),
        value: 1
      }, {
        label: this.$t('notShow'),
        value: 0
      }];
      this.paramsData.env_id = this.propsData.env_id;
      this.isUpd = type;
      this.dialogShow = true;

      if (type) {
        this.show_test = 1;
        this.paramsData.groupID = data.group_id;
        this.paramsData.groupName = data.groupName;
        this.server_channel = data.channels;
        this.serverID = data.server_ids.split(",").map(function (item) {
          return item = Number(item);
        });
        this.paramsData.pkgs = data.pkg;
        this.serverChannelChange();
      }
    },
    hiad: function hiad() {
      this.dialogShow = false;
      this.clearData();
    },
    clearData: function clearData() {
      this.serverID = [];
      this.serverChannel = [];
      this.server_channel = "";
      this.show_test = "";
      this.serverType = [];
      this.serverListYJ = [];
      this.paramsData = {
        groupID: '',
        groupName: '',
        channels: '',
        pkgs: []
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var groupData = {
            groupID: _this3.paramsData.groupID,
            groupName: _this3.paramsData.groupName,
            channels: _this3.server_channel,
            serverIDs: _this3.serverID.toString(),
            pkgs: _this3.paramsData.pkgs
          };
          var addData = {
            env_id: _this3.paramsData.env_id,
            group: JSON.stringify(groupData),
            game_id: _this3.rawData.game_id
          };

          var upDateData = _objectSpread(_objectSpread({
            env_id: _this3.paramsData.env_id
          }, groupData), {}, {
            game_id: _this3.rawData.game_id
          });

          var reqFn = _this3.isUpd ? updateModifyGroupState : addNewGroup;
          var sendData = _this3.isUpd ? upDateData : addData;
          reqFn(sendData).then(function (res) {
            if (res.status == 200) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('update');
            }
          });
        }
      });
    }
  }
};